<template>
  <BaseModal v-bind="modalPerfil">
    <template v-slot:header>
      <h3>{{ operationName }} perfil</h3>
    </template>

    <template v-slot:default>
      <BaseProgressBar v-if="loading" v-bind="progressBar"
        >Carregando dados do perfil...</BaseProgressBar
      >
      <div v-else>
        <InfoCard v-bind="infoCard" />

        <div class="row">
          <BaseTextInput v-bind="nome" v-model="perfil.nome" />
          <BaseTextarea v-bind="descricao" v-model="perfil.descricao" />
        </div>

        <section class="section">
          <h4>Atividades</h4>

          <div class="row">
            <BaseTypeahead
              ref="typeahead"
              v-bind="atividadeTypeahead"
              v-on:change="addAtividade"
            />
          </div>

          <div class="atividade-chips-wrapper">
            <BaseChip
              v-for="(item, index) in perfil.atividades"
              v-bind:key="index"
              v-bind:id="`${id}-atividade-${item.id}`"
              tabindex="0"
              v-on:delete="deleteAtividade(index)"
              >{{ item.nome }}</BaseChip
            >
          </div>
        </section>

        <BaseProgressBar v-if="saving" v-bind="progressBar"
          >Salvando perfil...</BaseProgressBar
        >
      </div>
    </template>

    <template v-slot:footer>
      <BaseButton
        class="modal-close"
        v-bind:disabled="disabled"
        material-type="flat"
        >Cancelar</BaseButton
      >
      <BaseButton
        material-type="flat"
        v-bind:disabled="disabled"
        v-on:click="save"
        >Salvar</BaseButton
      >
    </template>
  </BaseModal>
</template>

<script>
import { API_URL } from "../../constants";

const defaultPerfil = {
  nome: null,
  descricao: null
};

export default {
  name: "PerfilModal",
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      required: true
    },

    value: Number
  },
  data() {
    return {
      disabled: false,
      loading: false,
      saving: false,
      nome: {
        id: `${this.id}-nome`,
        label: "Nome",
        dataLength: 100
      },
      descricao: {
        id: `${this.id}-descricao`,
        label: "Descrição",
        dataLength: 255
      },
      perfil: { ...defaultPerfil, atividades: [] },
      perfilOriginal: { ...defaultPerfil, atividades: [] },
      atividadesMap: {},
      modalPerfil: {
        id: this.id,
        hasFixedFooter: true,
        modalOptions: {
          onOpenStart: this.onModalOpen,
          dismissible: false
        }
      },
      atividadeTypeahead: {
        id: `${this.id}-atividade-typeahead`,
        name: "atividade",
        label: "Permissão",
        placeholder: "Busque pelo nome da permissão",
        dropdownId: `${this.id}-atividade-dropdown`,
        searchFunction: this.searchAtividade,
        gridExpression: "col s12"
      },
      progressBar: {
        useContainer: false
      }
    };
  },
  computed: {
    operationName() {
      return this.perfil.id ? "Editar" : "Criar";
    },
    infoCard() {
      const id = `${this.id}-infocard`;

      const title = this.perfil.id ? "Edição de perfil" : "Criação de perfil";

      const contentPerfil = this.perfil.id
        ? "Para editar o perfil, primeiramente, caso necessário, altere seus nome e descrição."
        : "Para criar um perfil, deve-se definir um nome para ele e, opcionalmente, preencher uma descrição.";
      const contentAtividade = `Também pode-se (des)associar atividades ao perfil. Para desassociar uma atividade, basta clicar no respectivo
            ícone de fechar. Para associar uma atividade, digite um trecho do
            nome da atividade e escolha o item desejado dentre as opções da
            lista suspensa que será exibida.`;

      const content = `${contentPerfil} ${contentAtividade} Por fim, clique no botão Salvar.`;

      return { id, title, content };
    }
  },
  methods: {
    addAtividade(item) {
      if (!item) {
        return;
      }

      // Verifica, a partir de um map de controle, se a atividade
      // já foi adicionada no array
      if (!this.atividadesMap[item.id]) {
        this.perfil.atividades.push(
          this.$utils.Components.fromDropdownItem(item, "id", "nome")
        );
        this.atividadesMap[item.id] = true;
      }

      // Limpa o typeahead
      this.$refs.typeahead.clear();
    },
    deleteAtividade(index) {
      if (index >= 0) {
        delete this.atividadesMap[this.perfil.atividades[index].id];
        this.perfil.atividades.splice(index, 1);
      }
    },
    onModalOpen() {
      // Reseta algumas variáveis
      this.disabled = false;
      this.loading = false;
      this.saving = false;
      this.perfil = { ...defaultPerfil, atividades: [] };
      this.perfilOriginal = { ...defaultPerfil, atividades: [] };
      this.atividadesMap = {};
      // Limpa o typeahead
      this.$refs.typeahead.clear();

      // Se o componente não recebeu um id de perfil, a operação é de criação
      if (!this.value) {
        return;
      }

      this.loading = true;

      const perfilId = this.value;

      this.$http
        .get(`${API_URL}/acesso/perfil/${perfilId}`)
        .then(response => {
          const { id, nome, descricao, atividades } = response.data || {};

          this.perfil = { id, nome, descricao, atividades: atividades || [] };

          this.perfilOriginal = { id, nome, descricao };
          this.perfilOriginal.atividades = this.perfil.atividades.map(item => ({
            ...item
          }));

          this.perfil.atividades.forEach(
            item => (this.atividadesMap[item.id] = true)
          );
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao obter os dados do perfil: ${error.message}`
          )
        )
        .finally(() => (this.loading = false));
    },
    getPutData() {
      const putData = [];

      this.perfil.atividades.forEach(item => {
        const isItemFound =
          this.perfilOriginal.atividades.findIndex(
            originalItem => originalItem.id === item.id
          ) >= 0;

        if (!isItemFound) {
          putData.push(item);
        }
      });

      return putData;
    },
    getDeleteData() {
      const deleteData = [];
      const atividades = this.perfil.atividades;

      this.perfilOriginal.atividades.forEach(originalItem => {
        const isItemFound =
          atividades.findIndex(item => originalItem.id === item.id) >= 0;

        if (!isItemFound) {
          deleteData.push(originalItem);
        }
      });

      return deleteData;
    },
    isPerfilValid() {
      return !this.$utils.Lang.isEmpty(this.perfil.nome);
    },
    save() {
      if (!this.isPerfilValid()) {
        return this.$notification.pushError(
          "Dados do perfil inválidos. Verifique se pelo menos o nome está preenchido"
        );
      }

      let perfilId = this.perfil.id;

      const url = `${API_URL}/acesso/perfil`;

      const body = {
        nome: this.$utils.String.clear(this.perfil.nome),
        descricao: this.$utils.String.clear(this.perfil.descricao)
      };

      this.disabled = true;
      this.saving = true;

      let savePromise = null;

      if (perfilId) {
        if (
          body.nome !== this.perfilOriginal.nome ||
          body.descricao !== this.perfilOriginal.descricao
        ) {
          savePromise = this.$http
            .put(`${url}/${perfilId}`, body)
            .then(() =>
              this.$notification.pushSuccess("Perfil atualizado com sucesso")
            );
        } else {
          savePromise = Promise.resolve();
        }
      } else {
        savePromise = this.$http.post(url, body).then(response => {
          // Atualiza o objeto com o retorno do back-end para que,
          // em caso de erro em outras operações (e o modal permanecer aberto),
          // ao reenviar os dados, seja uma operação de atualização.
          this.perfil.id = response.data.id;
          this.perfilOriginal.nome = this.perfil.nome;
          this.perfilOriginal.descricao = this.perfil.descricao;

          this.$notification.pushSuccess("Perfil criado com sucesso");
        });
      }

      savePromise
        .then(() => {
          // Caso seja uma criação, obtém o id do perfil recém-criado
          perfilId = this.perfil.id;

          const putData = this.getPutData();
          const deleteData = this.getDeleteData();

          const saveData = [].concat(
            putData.map(item =>
              this.$http
                .put(
                  `${API_URL}/acesso/perfil/${perfilId}/atividade/${item.id}`
                )
                .then(() => {
                  // Atualiza os registros originais cujos correspondentes foram
                  // criados com sucesso para que, em caso de erro, os mesmos não
                  // sejam reenviados ao servidor desnecessariamente.
                  this.perfilOriginal.atividades.push(item);

                  this.$notification.pushSuccess(
                    `Atividade "${item.nome}" associada ao perfil com sucesso`
                  );
                })
            ),
            deleteData.map(item =>
              this.$http
                .delete(
                  `${API_URL}/acesso/perfil/${perfilId}/atividade/${item.id}`
                )
                .then(() => {
                  const index = this.perfilOriginal.atividades.findIndex(
                    itemOriginal => itemOriginal.id === item.id
                  );

                  // Atualiza os registros originais cujos correspondentes foram
                  // excluídos com sucesso para que, em caso de erro, os mesmos não
                  // sejam reenviados ao servidor desnecessariamente.
                  if (index >= 0) {
                    this.perfilOriginal.atividades.splice(index, 1);
                  }

                  this.$notification.pushSuccess(
                    `Atividade "${item.nome}" desassociada do perfil com sucesso`
                  );
                })
            )
          );

          return Promise.all(saveData).then(() => {
            // TODO: verificar se precisa enviar algum dado
            this.$emit("save", true);

            this.$utils.Components.closeModal(this.id);
          });
        })
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao ${this.operationName.toLowerCase()} perfil: ${
              error.message
            }`
          )
        )
        .finally(() => {
          this.disabled = false;
          this.saving = false;
        });
    },
    searchAtividade(value) {
      return this.$http
        .get(`${API_URL}/acesso/atividade/busca?query=${value}`)
        .then(response =>
          (response.data || []).map(item =>
            this.$utils.Components.toDropdownItem(item, "id", "nome")
          )
        )
        .catch(error =>
          this.$notification.pushError(
            `Houve um erro ao buscar pela atividade: ${error.message}`
          )
        );
    }
  }
};
</script>

<style scoped>
h3 {
  font-size: 2.28rem;
  margin: 1.52rem 0 0.912rem 0;
}
</style>
